module.exports = __webpack_public_path__ + "img/2019homepark-1.69c0f176.jpeg";